import axios, {AxiosRequestConfig} from "axios";

axios.defaults.baseURL = "https://newbalance.hyperlocals.app/web";

const axios_constants = {
    db: "newbalance"
}
export {axios_constants};
export default axios;
